// extracted by mini-css-extract-plugin
export default {"loadings":"GlobalStyle_loadings__1+JiB","responsive":"GlobalStyle_responsive__gxZn6","response":"GlobalStyle_response__bMUC-","visible":"GlobalStyle_visible__A6-HM"};